import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_FUNDER_EDUCATOR_SCHOOLS = gql`
  query ExportFunderEducatorSchools($input: ExportArgs!) {
    allFunderEducatorSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
